import React from "react";
import { Navigate, Route, Routes } from "react-router";
import {
  ACCOUNT_ACTIVATION,
  BIRTHDAY_RESERVATION,
  CALENDAR_SALE,
  CARD_PURCHASE_LOOKUP,
  CHANGE_PASSWORD_CONFIRMATION,
  CUSTOM_OFFER,
  ECARD_RECHARGE,
  EVENT_SALE,
  EXERCISE_SCHEDULE,
  FINALIZE_PAGE,
  GDANSK_SALE,
  GIFT_CARD_ACTIVE,
  HOURLY_SCHEDULE,
  LIMITED_TICKET_COLOR,
  LIMITED_TICKET_GROUP,
  LIMITED_TICKET_SHAPE,
  LOGIN_PAGE,
  MAIN_APP,
  MODAL_TEST,
  NEWSLETTER_CONFIRMATION,
  NEWSLETTER_FORM_RESIGN,
  NEWSLETTER_FORM_WIDGET,
  NEWS_PAGE,
  OFFER_SHOWCASE,
  PASSES_SALE,
  PURCHASE,
  PURCHASE_FAILED,
  REGISTER_B2B,
  REGISTER_PARTICIPANTS_PAGE,
  REGISTRATION_PAGE,
  REGISTRATION_SUCCESS_PAGE,
  REMIND_PASS_PAGE,
  THREE_STEP,
  TOUR_DETAILS,
  TOUR_SALE,
  WELCOME_MOBILE,
  PWA_INSTRUCTION,
  PROMO,
  ADD_SUBACCOUNT_PAGE,
  SWIMMING_COURSE_OFFER,
} from "../../routes";
import BirthdayReservation from "../BirthdaysReservation";
import CalendarSale from "../CalendarSale";
import CardRecharge from "../eCardRecharge";
import EventSale from "../EventSale";
import FinalizePage from "../FinalizePage";
import GiftCard from "../GiftCardActive";
import LimitedTicketShapePage from "../LimitedTicket";
import LimitedTicketColorPage from "../LimitedTicket/LimitedTicketColorPage";
import LimitedTicketGroupPage from "../LimitedTicket/LimitedTicketGroupPage";
import Login from "../Login";
import useAuth from "../Login/hooks/useAuth";
import NewsPage from "../NewsPage";
import PassesPage from "../Passes";
import Registration from "../Registration";
import RegistrationSuccess from "../Registration/RegistrationSuccess";
import RemindPass from "../RemindPass";
import ScheduleExerise from "../ScheduleExercise";
import ModalWindow from "../ModalWindow";
import ThreeStepSale from "../ThreeStep";
import PurchaseSuccess from "../PurchaseSuccess";
import MobileFirstScreen from "../MobileFirstScreen";
import AccountActivated from "../AccountActivated";
import PurchaseFailed from "../PurchaseFailed";
import HourlySchedule from "../HourlySchedule";
import NewsletterFormWidget from "../NewsletterFormWidget";
import NewsletterConfirmation from "../NewsletterConfirmation";
import ChangePasswordForm from "../ChangePasswordForm";
import { getDefaultLink } from "../../../utils/getDefaultLink";
import { useSelector } from "react-redux";
import { State } from "../../store";
import NotFoundPage from "../NotFoundPage";
import GdanskSale from "../GdanskSale";
import NewsletterFormResign from "../NewsletterFormResign";
import TourSale from "../TourSale";
import TourDetails from "../TourSale/TourDetails";
import useParentRouting from "../../../utils/hooks/useParentRouting";
import CustomOffer from "../CustomOffer";
import OfferShowcase from "../OfferShowcase";
import RegisterB2BPage from "../RegisterB2BPage";
import RegisterParticipants from "../RegisterParticipants";
import useSavePreviousPage from "../../../utils/hooks/useSavePreviousPage";
import usePageView from "../../../utils/Analitics/GtmHooks/useGTMPageView";
import CardPurchaseLookup from "../CardPurchaseLookup";
import FreeEntryPromo from "../PWAButton/FREE";
import InstallInstructions from "../PWAButton/InstallInstructions";
import MyAccountV2 from "../MyAccountV2";
import AddSubaccount from "../AddSubaccount";
import SwimmingCourseOffer from "../SwimmingCourseOffer";

const RoutesComponent: React.FC = () => {
  useParentRouting();
  const { isLoggedIn } = useAuth();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  useSavePreviousPage();
  usePageView();

  const defaultLink = getDefaultLink(saleConfiguration.componentList);
  return (
    <React.Fragment>
      <Routes>
        <Route path={MAIN_APP} caseSensitive element={<Navigate to={defaultLink} />} />
        <Route path={LOGIN_PAGE} element={isLoggedIn ? <MyAccountV2 /> : <Login />} />
        <Route path={REMIND_PASS_PAGE} element={<RemindPass />} />
        <Route path={REGISTRATION_PAGE} element={<Registration />} />
        <Route path={REGISTRATION_SUCCESS_PAGE} element={<RegistrationSuccess />} />
        <Route path={FINALIZE_PAGE} element={<FinalizePage />} />
        <Route path={NEWS_PAGE} element={<NewsPage />} />
        <Route path={LIMITED_TICKET_COLOR} element={<LimitedTicketColorPage />} />
        <Route path={LIMITED_TICKET_GROUP} element={<LimitedTicketGroupPage />} />
        <Route path={LIMITED_TICKET_SHAPE} element={<LimitedTicketShapePage />} />
        <Route path={EVENT_SALE} element={<EventSale />} />
        <Route path={TOUR_SALE} element={<TourSale />} />
        <Route path={CALENDAR_SALE} element={<CalendarSale />} />
        <Route path={CUSTOM_OFFER} element={<CustomOffer />} />
        <Route path={OFFER_SHOWCASE} element={<OfferShowcase />} />
        <Route path={PASSES_SALE} element={<PassesPage />} />
        <Route path={EXERCISE_SCHEDULE} element={<ScheduleExerise />} />
        <Route path={GIFT_CARD_ACTIVE} element={<GiftCard />} />
        <Route path={BIRTHDAY_RESERVATION} element={<BirthdayReservation />} />
        <Route path={ECARD_RECHARGE} element={<CardRecharge />} />
        <Route path={THREE_STEP} element={<ThreeStepSale />} />
        <Route path={MODAL_TEST} element={<ModalWindow />} />
        <Route path={TOUR_DETAILS} element={<TourDetails />} />
        <Route path={PURCHASE} element={<PurchaseSuccess />} />
        <Route path={PURCHASE_FAILED} element={<PurchaseFailed />} />
        <Route path={WELCOME_MOBILE} element={<MobileFirstScreen />} />
        <Route path={ACCOUNT_ACTIVATION} element={<AccountActivated />} />
        <Route path={HOURLY_SCHEDULE} element={<HourlySchedule />} />
        <Route path={NEWSLETTER_FORM_WIDGET} element={<NewsletterFormWidget />} />
        <Route path={NEWSLETTER_CONFIRMATION} element={<NewsletterConfirmation />} />
        <Route path={NEWSLETTER_FORM_RESIGN} element={<NewsletterFormResign />} />
        <Route path={CHANGE_PASSWORD_CONFIRMATION} element={<ChangePasswordForm />} />
        <Route path={GDANSK_SALE} element={<GdanskSale />} />
        <Route path={REGISTER_B2B} element={<RegisterB2BPage />} />
        <Route path={REGISTER_PARTICIPANTS_PAGE} element={<RegisterParticipants />} />
        <Route path={CARD_PURCHASE_LOOKUP} element={<CardPurchaseLookup />} />
        <Route path={PWA_INSTRUCTION} element={<InstallInstructions />} />
        <Route path={PROMO} element={<FreeEntryPromo />} />
        <Route path={ADD_SUBACCOUNT_PAGE} element={<AddSubaccount />} />
        <Route path={SWIMMING_COURSE_OFFER} element={<SwimmingCourseOffer />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </React.Fragment>
  );
};

export default RoutesComponent;
